// Port of api/fuel/app/classes/insights/ratings/distribution.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'distribution',
    priority: 1,
    default_: true,
    requires: [],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_ratings()) return {}

        var self = this

        if (detail) {

            var games = []

            var results = Util.query('\
                SELECT \
                    r.game_id AS g, \
                    r.rating_value AS r \
                FROM \
                    rating r, \
                    game g \
                WHERE \
                    r.game_id = g.game_id \
                    AND \
                    r.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    CAST(r.rating_value AS INTEGER) = ' + vars.rating + ' \
                ORDER BY \
                    g.game_sortname ASC \
            ')

            for (var i = 0; i < results.length; i++) {
                var item = results[i]

                self._references.games.push(parseInt(item.g, 10))

                games.push({
                    id: parseInt(item.g, 10),
                    rating: parseFloat(item.r)
                })
            }

            return {
                rating: vars.rating,
                games: games
            }

        } else {

            var sqlResults = Util.query('\
                SELECT \
                    group_concat(DISTINCT r.game_id) as games, \
                    CAST(r.rating_value AS INTEGER) AS rating, \
                    COUNT(r.rating_id) AS ratings \
                FROM \
                    rating r \
                WHERE \
                    r.user_id IN (' + Util.in(userIndex) + ') \
                GROUP BY \
                    CAST(r.rating_value AS INTEGER) \
            ')

            var ratingCounts = {}
            var totalRatings = 0

            for (var si = 0; si < sqlResults.length; si++) {
                var result = sqlResults[si]

                var featured = result.games ? result.games.split(',') : []
                featured = featured.map(function(id) { return parseInt(id, 10) }).filter(function(id) { return id > 0 }).sort(function(a, b) { return a - b })
                var deterministicFeatured = featured.length ? featured[0] : 0

                ratingCounts[result.rating] = {
                    value: parseInt(result.ratings, 10),
                    game: deterministicFeatured
                }

                totalRatings += parseInt(result.ratings, 10)
            }

            return {
                distribution: ratingCounts,
                totalRatings: totalRatings
            }

        }

    }
})
